import React, { useEffect ,useState} from 'react'
import FetchCMCategoriesService from '../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMCategoriesService'; 
import { connect } from "react-redux";
import { Col, Row } from 'reactstrap';
import GetCMFileListBySubCategoryService from '../../../../../../Service/DashboardServices/ContentManagementServices/GetCMFileListBySubCategoryService';
import ProjectDashBrandInterviewAndAudit from './ProjectAssets/Documents/ProjectDashBrandInterviewAndAudit';
import ProjectDashGraphicQA from './ProjectAssets/Graphics QA/ProjectDashGraphicQA';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import FetchAllCMOriginalFilesByAssetIdentifierService from '../../../../../../Service/DashboardServices/ContentManagementServices/FetchAllCMOriginalFilesByAssetIdentifierService';
import ProjectDashDeliveries from './ProjectAssets/Deliveries/ProjectDashDeliveries';
import ProjectDashSubmissionMainPage from './ProjectAssets/Submissions/ProjectDashSubmissionMainPage';
import ProjectAsinCardsUi from './ProjectAssets/Graphics QA/ProjectAsinCardsUi';

function ProjectsDashAssetsMainPage(props) {
  const [subCategories, setSubCategories] = useState()
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [fileStatus, setFileStatus] = useState('')
  const [filterSubcategoryList, setFilterSubcategoryList] = useState()
  const [filterProductSubcategoryList, setFilterProductSubcategoryList] = useState()
  const [selectedSubCategories, setSelectedSubCategories] = useState('')
  const [allOriginalFiles, setAllOriginalFiles] = useState([]);
  const [loggedInUser,setLoggedInUser]= useState('')
  const [assetsStatusCount,setAssetsStatusCount]=useState({})
  

  useEffect(() => {
    console.log(props.selectedProjectData);
    let data1={
      projectId:props.selectedProjectData.projectId
    }
    FetchCMCategoriesService(props.token,data1).then((res) => {
      if (res) {
        console.log(res);
        setSubCategories(res.subCategory);
    
        const allowedSubCategories = res.subCategory.filter((sub) => {
          const permission = permitionsArray.find(
            (perm) => perm.text === sub.subCategoryName || (perm.id === sub.id && perm.value)
          );
          return sub.assetCategory === 3 && permission && permission.value === true;
        });
    
        if (allowedSubCategories.length > 0) {
          setSelectedSubCategories(allowedSubCategories[0]);
          handleSelectedSubtabs(allowedSubCategories[0]);
        }
      }
    });
    let data = {
      projectId: props.selectedProjectData.projectId? props.selectedProjectData.projectId:''
    }

    FetchAllCMOriginalFilesByAssetIdentifierService(props.token, data).then((response) => {
      if (response) {
        console.log(response)
        setAllOriginalFiles(response)
      }
    })
  }, [props.page ]);
  
  const handleSelectedSubtabs = (tabs) => {
    console.log(tabs);
    setSelectedSubCategories(tabs)
    // 1-> Questionnaire and 3-> Assets
    if( tabs.id == 5 ) {
      console.log('if condition');
    setLoading(true)

      let data = {
        integerId: props.selectedProjectData.integerId,
        assetCategory: tabs.assetCategory,
        assetIdentifier: props.selectedProjectData.brand,
        subCategoryId: tabs.id,
        // asin:'',
        projectId:props.selectedProjectData.projectId,

      }

      GetCMFileListBySubCategoryService(props.token, data).then((res) => {
        if (res) {
          console.log(res);
          setFileList(res.fileList)
          setLoggedInUser(res.loggedInUser)
          setFileStatus(res.statusList)
          setFilterProductSubcategoryList(res.productSubcategoryList)
          setFilterSubcategoryList(res.brandSubcategoryList)
          setLoading(false) 
           // Set status count if available
        if(res.assetStatusCount){
          console.log('Status count:', res.assetStatusCount)
          setAssetsStatusCount(res.assetStatusCount)
        }
        }
      })
    } else if (tabs.id == 8 || tabs.subCategoryName === 'Submissions') {
      // Load brand + document destination categories for Submissions popup
      let data = {
        integerId: props.selectedProjectData.integerId,
        assetCategory: tabs.assetCategory,
        assetIdentifier: props.selectedProjectData.brand,
        subCategoryId: tabs.id,
        projectId: props.selectedProjectData.projectId,
      };
      GetCMFileListBySubCategoryService(props.token, data).then((res) => {
        if (res) {
          setFilterProductSubcategoryList(res.productSubcategoryList);
          setFilterSubcategoryList(res.brandSubcategoryList);
          if (res.statusList) setFileStatus(res.statusList);
        }
      });
    }
   
  }
const permitionsArray = [
  {
    id:5,
    text: "Approved Design Files",
    value: props.projectPermissions? props.projectPermissions.ProjectDetailsProjectAssets_Documents: false,
  },
  {
    id:7,
    text: "Graphics QA",
    value: props.projectPermissions? props.projectPermissions.ProjectDetailsProjectAssets_GraphicsQA: false,
  },
  {
    id:8,
    text: "Submissions",
    value: props.projectPermissions? props.projectPermissions.ProjectDetailsProjectAssets_Submissions: false,
  },
  {
    id:9,
    text: "Deliveries",
    value: props.projectPermissions
      ? props.projectPermissions.ProjectDetailsProjectAssets_Deliveries: false,
  },
  // {
  //   id:10,
  //   text: "Notifications",
  //   value: true,
  // },
];
  return (
  <>
  {selectedSubCategories.subCategoryName !== 'Deliveries' && (
  <Row className="mt-3">
            <Col>
              <div className="brand-tabs  ml-3 mb-2">
                {/* 3 ==assetCategory  Projects*/}
                {subCategories &&
                subCategories
                  .filter((sub) => (sub.assetCategory === 3 && sub.id !== 9))
                  .filter((sub) => {
                    const permission = permitionsArray.find(
                      (perm) => perm.text === sub.subCategoryName || (perm.id === sub.id && perm.value)
                    );
                    return permission && permission.value === true;
                  })
                  .map((sub) => (
                    <span
                      key={sub.id}
                      className={`main-tabs ${
                        selectedSubCategories.id === sub.id ? "active" : ""
                      }`}
                      // className={`main-tabs ${
                      //   sub.subCategoryName === "Notifications" ? "notifications-tab" : ""
                      // } ${selectedSubCategories.id === sub.id ? "active" : ""}`}
                      onClick={() => handleSelectedSubtabs(sub)}
                    >
                      {sub.subCategoryName}
                      {/* <b
                className="assetsStatusCount"
                style={{
                  minWidth: `${Math.max(16, sub.subCatCount.toString().length * 10)}px`,
                  minHeight: `${Math.max(16, sub.subCatCount.toString().length * 10)}px`,
                  padding: `4px ${Math.max(6, sub.subCatCount.toString().length * 3)}px`
                }}
              >
                {sub.subCatCount}
              </b> */}
                    </span>
                  ))}
              </div>
            </Col>
          </Row>
          )}
          <LoadingOverlay
            active={loading && selectedSubCategories.subCategoryName !== 'Notifications'}
            styles={{
              overlay: (base) => ({
                ...base,
                background: '#fff',
                opacity: 1,
              }),
              content: (base) => ({
                ...base,
                color: '#000',
              }),
            }}
            spinner={<Loader active type="ball-pulse" />}
            text='Loading your Project Assets...'
          >
            {
              (selectedSubCategories.subCategoryName === 'Approved Design Files' ||
                selectedSubCategories.subCategoryName === 'Documents' ||
                selectedSubCategories.id === 5) &&
              <ProjectDashBrandInterviewAndAudit
              fileList={fileList}
              setFileList={setFileList}
              fileStatus={fileStatus}
              setAssetsStatusCount={setAssetsStatusCount}
              projectPermissions={props.projectPermissions}
              selectedProjectData={props.selectedProjectData}
              selectedSubCategories={selectedSubCategories}
              filterSubcategoryList={filterProductSubcategoryList}
              assetsStatusCount={assetsStatusCount}
            />
            }
            {selectedSubCategories && selectedSubCategories.subCategoryName == 'Graphics QA' &&
        <ProjectAsinCardsUi
          projectPermissions={props.projectPermissions}
          selectedSubCategories={selectedSubCategories}
          selectedProjectData={props.selectedProjectData}
        />
      }
      {selectedSubCategories && selectedSubCategories.subCategoryName == 'Submissions' &&
        <ProjectDashSubmissionMainPage
          fileList={fileList}
          setFileList={setFileList}
          fileStatus={fileStatus}
          selectedProjectData={props.selectedProjectData}
          projectPermissions={props.projectPermissions}
          selectedSubCategories={selectedSubCategories}
          filterSubcategoryList={filterSubcategoryList}
          filterProductSubcategoryList={filterProductSubcategoryList}
        />
      }
      {selectedSubCategories && selectedSubCategories.subCategoryName == 'Deliveries' &&
        <ProjectDashDeliveries
          fileList={fileList}
          projectPermissions={props.projectPermissions}
          setFileList={setFileList}
          fileStatus={fileStatus}
          selectedProjectData={props.selectedProjectData}
          selectedSubCategories={selectedSubCategories}
          filterSubcategoryList={filterSubcategoryList}
        />
      }
      {/* {selectedSubCategories && selectedSubCategories.subCategoryName == 'Notifications' &&
        <NotificationsMainFile
        searchparams={props.selectedProjectData.projectId}
        hideProjectDashNotifications={true}
        filterType="projectsOnly"
        flag='true'
       />
      } */}
            </LoadingOverlay>
  </>
  )
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
  UserPermission: state.accountOverview.store.StoreUserPermission,
});

export default connect(mapStateToProps)(ProjectsDashAssetsMainPage);
